import React, { useState } from 'react'

import PermissionsChecker from '@shared/PermissionsChecker'
import { PixPaymentModal } from '../Pix/PixPaymentModal'

const CancelButton = ({ orderStatus, payment, onCancelOrder }) => {
  if (orderStatus === 'C' && payment !== 'PIX') {
    return (
      <PermissionsChecker permissions={['cancel_order_billet']}>
        <button
          className="button button__small bg-darkgray card-request-detail__billetbutton"
          onClick={() => {
            onCancelOrder()
          }}
        >
          {payment === 'Cartão de crédito' ? 'Solicitar estorno' : 'Cancelar boleto'}
        </button>
      </PermissionsChecker>
    )
  }
  return null
}

const CardRequestDetail = props => {
  let {
    payment,
    due,
    icon,
    subtotal,
    prev_subtotal,
    total,
    original_total,
    freight,
    status,
    paymentCondition,
    paymentType,
    orderStatus,
    onCancelOrder,
    billetUrl,
    discount,
    buyer_name,
    created,
    estimated_delivery_date,
    immediate_delivery,
    pix: pixOrder,
  } = props

  const [showPixModal, setShowPixModal] = useState(false)

  const isImmediateDelivery = immediate_delivery == 1

  return (
    <div className="card-request-detail">
      <div className="card-request-detail__wrapper row-xs">
        <div className="card-request-detail__column">
          <span className="card-request-detail__header">Data da compra</span>
          <span className="card-request-detail__value">{created}</span>
        </div>
        {(isImmediateDelivery || estimated_delivery_date) && (
          <div className="card-request-detail__column">
            <span className="card-request-detail__header">Previsão de entrega</span>
            <span className="card-request-detail__value">
              {isImmediateDelivery
                ? 'Em 48 horas ou de acordo com orientação da escola'
                : new Date(estimated_delivery_date + 'T00:00:00').toLocaleDateString('pt-BR')}
            </span>
          </div>
        )}
        <div className="card-request-detail__column">
          <span className="card-request-detail__header">Comprador(a)</span>
          <span className="card-request-detail__value">{buyer_name}</span>
        </div>
      </div>
      <div className="card-request-detail__wrapper column-xs">
        <div className="card-request-detail__column">
          <span className="card-request-detail__header">Forma de pagamento</span>
          <div className="card-request-detail__payment_type">
            <img className="card-request-detail__icon" src={icon} alt="" />
            <div>
              <span className="card-request-detail__value">{payment?.name}</span>
              {paymentType === 'R' ? (
                payment.cards ? <span className="card-request-detail__desc">
                  {payment.cards.map((card, index) => {
                    return <div key={index} style={{display: 'flex', flexDirection:'column'}}>
                        <strong style={{color: '#2E5496'}}>Cartão final {card.card_number}</strong>
                        <span>{parseFloat(card.total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} em {card.payment_condition}x s/ juros</span>
                    </div>
                  })}
              </span>: <span className="card-request-detail__desc">
                  {original_total} em {paymentCondition}x s/ juros
                </span>
              ) : (
                <span className="card-request-detail__desc">{due}</span>
              )}
              <CancelButton orderStatus={orderStatus} payment={payment?.name} onCancelOrder={onCancelOrder} />
              {(orderStatus === 'NP' || orderStatus === 'BAP') && billetUrl && (
                <button
                  className="button button__small bg-darkgray card-request-detail__billetbutton"
                  onClick={() => window.open(billetUrl)}
                >
                  2º via de boleto
                </button>
              )}
              {orderStatus === 'PW' && (
                <button
                  className="button button__small bg-darkgray card-request-detail__billetbutton"
                  onClick={() => setShowPixModal(true)}
                >
                  Ver chave PIX
                </button>
              )}
              {pixOrder?.txid && (
                <span className="card-request-detail__desc">
                  ID: {pixOrder.txid}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="card-request-detail__column paymente_detail">
          <div className="card-request-detail__paymente_detail">
            <span className="card-request-detail__header">Subtotal</span>
            {prev_subtotal && <span className="card-request-detail__value dashed">{prev_subtotal}</span>}
            <span className="card-request-detail__value">{subtotal}</span>
          </div>
          <div className="card-request-detail__paymente_detail">
            <span className="card-request-detail__header">Desconto</span>
            <span className="card-request-detail__value">{discount}</span>
          </div>
          <div className="card-request-detail__paymente_detail">
            <span className="card-request-detail__header">Frete</span>
            <span className="card-request-detail__value">{freight}</span>
          </div>
          <div className="card-request-detail__paymente_detail _total">
            <span className="card-request-detail__value">{parseFloat(total?.replace(/[^0-9,-]/g, '').replace(',', '.')) < 0 ? 'R$ 0,00' : total}</span>
          </div>
        </div>
      </div>
      <div className="card-request-detail__status-container">{status}</div>
      {showPixModal && <PixPaymentModal order={pixOrder} total={total} onClose={() => setShowPixModal(false)} />}
    </div>
  )
}

export default CardRequestDetail

